//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import HeaderCpt from "@/components/HeaderCpt";
	import FooterCpt from "@/components/FooterCpt";
	import Interval from "@/components/tool/Interval";

	export default {
		name: 'App',
		components: {
			HeaderCpt,
			FooterCpt,
      Interval
		},
		data: function() {
			return {
				token: "",
				keyword: "",
				isShow: false,

				peoplelist: []
			}
		},
		created: function() {

			//分享的地址处理
			var url = window.location.href;
			var path = this.getRequest("jumpPath");

			if (path != null && path == "shhgxy") {
				this.$router.push('ShhgxyLogin')
			} else {
				var isShare = false;
				//处理携带的课程和章节信息
				var CourseID = this.getRequest("IDCode");
				var CourseCap = this.getRequest("ChapterID");
				if (CourseID != null) {
					window.localStorage.setItem("NowCourse", CourseID);
					window.localStorage.setItem("NowChapterID", CourseCap);

					this.$router.push({
						path: "/Index/Course",
						name: "/Index/Course",
						params: {
							IDCode: CourseID,
							ChapterID: CourseCap,
							level1: "我的课程",
						}
					});
					isShare = true;

				}

				//处理登录后的用户信息
				var token = this.getRequest("access_token");
				var userId = this.getRequest("user_id");
				var HasLoginOut = this.getRequest("HasLoginOut");
				if (HasLoginOut != null) {
					window.localStorage.setItem("HasLoginOut", "true");
				}


				if (userId != null && token != null) {
					this.GLOBAL.isLogin = true;
				} else {
					userId = window.localStorage.getItem("userId");
					token = window.localStorage.getItem("accessToken");
				}
				if (userId != null && token != null) { //浏览器缓存
					this.$api.UpdateUserData(userId, token)
						.then((response) => {
							if (response.data.Status != 0) {
								return false;
							}
							var json = response.data.Data;

							var agencyIP = json.ip;
							var agencyDomain = json.domain;
							window.localStorage.setItem("orgId", json.schoolId);
							window.localStorage.setItem("orgnam", json.schoolName);
							window.localStorage.setItem("userName", json.username);
							window.localStorage.setItem("userId", json.userId);
							window.localStorage.setItem("headImg", json.middleAvatar == null ? "" : json.middleAvatar);
							window.localStorage.setItem("role", JSON.stringify(json.role));
							window.localStorage.setItem("accessToken", json.token);
							window.localStorage.setItem("isLogged", true);
							window.localStorage.setItem("ipVerified", json.ipRangeVerified);
							window.localStorage.setItem("agencyURL", json.domain);
							this.GLOBAL.isLogin = true;

							//游客且 ip未通过验证 选择机构进行注册
							window.localStorage.setItem("isTem", json.isTem);
							if (json.isTem == false && json.schoolId == "527" && json.schoolName == "游客") {
								//this.isShow = true;
								//this.getOrgList(30);
							}

							this.$api.GetUserInf(token)
								.then((data) => {
									if (data.data.Status != 0) {
										return false;
									}
									window.localStorage.setItem("UserID", data.data.Data.user.ID);
								})

							this.SetAllInfo(json.role);

						})



				} else { //游客登录
					this.$api.TouristLogin().then((response) => {
							if (response.data.Status != 0) {
								return false;
							}
							var json = response.data.Data;
							window.localStorage.setItem("orgId", json.OrgID);
							window.localStorage.setItem("orgname", json.schoolName);
							window.localStorage.setItem("isLogged", false);
							window.localStorage.setItem("ipVerified", json.IpRangeVerified);

							var role = null;
							if (json.IsVisitor) {
								//游客
								role = [{
									"id": "4",
									"item": "auser",
									"isSysIn": null,
									"description": "不属于机构IP段内，也没有注册的临时用户",
									"addTime": "1505182729",
									"projectNo": this.$api.PROJECTNO,
									"name": "匿名用户"
								}];
							} else {
								role = [{
									"id": "5",
									"item": "tuser",
									"isSysIn": null,
									"description": "属于授权机构IP段内的但是未注册的临时用户",
									"addTime": "1641866832",
									"projectNo": "sft",
									"name": "机构临时用户"
								}];
								/* 用来处理ip段内还需要登录的部署
								role = [{
								  "id": "22",
								  "item": "tuser2",
								  "isSysIn": null,
								  "description": "属于授权机构IP段内的但是未注册的临时用户,不继承机构权限",
								  "addTime": "1641866832",
								  "projectNo": "sft",
								  "name": "机构临时用户2"
								}]; */
							}
							this.SetAllInfo(role);
						})

				}

				if (isShare == false) {
					this.$router.push("/IndexCourse");
				}
			}

		},
		methods: {
			getRequest(name) {
				var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
				var r = window.location.search.substr(1).match(reg);
				if (r != null) return (r[2]);
				return null;
			},
			SetAllInfo: function(role) {



				var viewVideo = false; //true可以无限制看视频
				var item = "";
				var roleList = role;
				if (roleList.length > 0) {
					item = roleList[0].item;
				}
				//是否可以无限制观看视频
				if (item != "iuser" && item != "auser" && item != "tuser2") {
					viewVideo = true;
				}
				if (window.localStorage.getItem("isTem") == "true") {

					viewVideo = true;
				}
				this.GLOBAL.viewVideo = viewVideo;
				window.localStorage.setItem("viewVideo", viewVideo);

			},
			getOrgList: function(pagesize) {

				this.$api.getOrgList(this.keyword, pagesize)
					.then((response) => {
						if (response.data.Status != 0) {
							return false;
						}

						var item = eval('(' + response.data.Data + ')');
						var idList = new Array();
						var peoplelists = [];
						item.data.rows.forEach(function(items) {
							var obj = new Object();
							obj.id = items.id;
							obj.name = items.name;
							peoplelists.push(obj);

							idList.push(items.id);
						})
						this.peoplelist = peoplelists;

					})

			},
			selectOrg: function(name, id) {
				const _this = this;
				this.$vux.confirm.show({
					title: "您确定选择机构  " + name + "  ？",
					onConfirm() {
						var accessToken = window.localStorage.getItem("accessToken");
						window.localStorage.setItem("viewVideo", true);

						_this.GLOBAL.viewVideo = true;
						_this.isShow = false;
						_this.$api.selectOrg(accessToken, id)
							.then((response) => {
								if (response.data.Status != 0) {
									return false;
								}
							})
					}
				})


			}
		}
	}



// WEBPACK FOOTER //
// ./src/App.vue